export default {
  name: "stories",
  component() {
    const stories = Array.from(
      this.$refs.stories.querySelectorAll(".orsay-story")
    ) as HTMLDivElement[];
    return {
      open: false,
      currentStory: {
        index: 1,
        el: null,
        isPlaying: false,
      },

      init() { },

      openStory(index: number) {
        this.open = true;
        this.currentStory = {
          index,
          el: stories[index - 1],
          isPlaying: false,
        };
        this.playStory();
        this.updateProgress();
      },

      playStory() {
        this.currentStory.isPlaying = true;
        this.currentStory?.el?.querySelector("video")?.play();
      },

      pauseStory() {
        this.currentStory.isPlaying = false;
        this.currentStory?.el?.querySelector("video")?.pause();
      },

      closeStories() {
        this.open = false;
        this.currentStory = {
          index: 1,
          el: null,
          isPlaying: false,
        };
        this.muteStories();
      },

      muteStories() {
        stories.forEach((story) => {
          const video = story.querySelector("video");
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });
      },

      updateProgress() {
        const video = this.currentStory?.el?.querySelector("video");
        const progressBar = this.currentStory?.el?.querySelector(
          ".orsay-story__progress-bar-line"
        ) as HTMLElement;
        if (!video || !progressBar) return;

        const updateFrame = () => {
          const progress = video.currentTime / video.duration;
          if (progressBar) {
            progressBar.style.transform = `scaleX(${progress})`;
          }
          this.animationFrameId = requestAnimationFrame(updateFrame);
        };

        this.animationFrameId = requestAnimationFrame(updateFrame);
      },

      cancelProgressUpdate() {
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
        }
      },
    };
  },
};
